/* ---------------------------------------------------------------------------
 * Club 1984 — built by Fabrik
 * https://fabrik.ae
 *
 * Growth studio for fashion and footwear brands.
 * Design, build and merchandising systems on Shopify.
 * ------------------------------------------------------------------------- */

/* Club 1984 — size guide drawer.
 *
 * Opens from any "Size guide" control on the page, including Symmetry's own
 * variant-picker link, so the merchant does not have to choose between the two.
 * Inches are derived from the cm values in the markup rather than stored twice.
 */
(function () {
  const drawer = () => document.querySelector('[data-c84-size-guide]');

  function open() {
    const el = drawer();
    if (!el) return;
    el.hidden = false;
    document.body.style.overflow = 'hidden';
    const close = el.querySelector('[data-c84-sg-close]');
    if (close) close.focus();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    const el = drawer();
    if (!el) return;
    el.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
  }

  function onKey(event) {
    if (event.key === 'Escape') close();
  }

  function setUnit(unit) {
    const el = drawer();
    if (!el) return;

    el.querySelectorAll('[data-c84-sg-unit]').forEach((button) => {
      const on = button.dataset.c84SgUnit === unit;
      button.classList.toggle('c84-sg__unit--on', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    el.querySelectorAll('td[data-cm]').forEach((cell) => {
      const cm = parseFloat(cell.dataset.cm);
      if (Number.isNaN(cm)) return;
      cell.textContent = unit === 'in' ? (cm / 2.54).toFixed(1) : String(cm);
    });
  }

  function boot() {
    const el = drawer();
    if (!el) return;

    /* The block renders inside .product-column-right, which is position:sticky.
       A fixed-position drawer nested there does not resolve against the
       viewport, so it rendered full-width instead of as a 520px right panel.
       Reparent to <body> once. */
    if (el.parentElement !== document.body) document.body.appendChild(el);

    el.querySelectorAll('[data-c84-sg-close]').forEach((b) => b.addEventListener('click', close));
    el.querySelectorAll('[data-c84-sg-unit]').forEach((b) =>
      b.addEventListener('click', () => setUnit(b.dataset.c84SgUnit))
    );

    /* The chart is only useful if it is showing the size the customer is on,
       so the highlighted column follows the size selector rather than being
       fixed at whatever was selected when the page rendered. */
    const syncSize = () => {
      const picked = document.querySelector(
        '.product-column-right .opt-btn:checked, .js-product .opt-btn:checked'
      );
      if (!picked) return;
      const label = (picked.value || '').split(' / ')[0].trim().toLowerCase();
      if (!label) return;
      el.querySelectorAll('[data-size]').forEach((cell) => {
        cell.classList.toggle('c84-sg__col--on', cell.dataset.size === label);
      });
    };
    document.addEventListener('change', (event) => {
      if (event.target.closest('.opt-btn, .option-selector')) syncSize();
    });
    syncSize();

    /* Symmetry wraps its size-chart button in <modal-opener>, which opens the
       legacy PNG modal. Listen in the CAPTURE phase and stop the event before
       that handler runs, so only the 4.16 drawer opens. */
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(
        '[data-c84-sg-open], .c84-sizeguide-link, .size-chart-link, [data-size-chart]'
      );
      if (!trigger) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      open();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
